import React from 'react'
import { PageHeader } from 'ui'
import { Translator } from '@morningtrain/react-translations'
import TranslatedTitle from 'widgets/TranslatedTitle'
import AdminPage from 'pages/app/AdminPage'
import EmployeeFileTags from 'pages/app/files/partials/EmployeeFileTags'

export default function ViewEmployeeFiles () {
  return (
    <AdminPage withGlobalDepartmentFilter={false}>
      <Translator namespace='files.employee_files'>
        <PageHeader title={<TranslatedTitle name='titles.view' />} />
        <EmployeeFileTags />
      </Translator>
    </AdminPage>
  )
}
